import * as yup from 'yup';
import { CheckboxTextSchema, ICheckboxValue } from '../../../common';
import { PainType } from '../../../enums/Pain';
import { values } from '../../../enums';

export const PainSchema = yup.object({
  discontinued: yup.boolean().notRequired().nullable(),
  painType: yup.mixed<PainType>().oneOf(values(PainType)).required(),
  localizationIsNotAssessable: yup.boolean().notRequired().nullable(),
  painLocation: yup.mixed().when('localizationIsNotAssessable', {
    is: false,
    then: yup.string().required(),
  }),
  painLocationType: yup.mixed().when('localizationIsNotAssessable', {
    is: false,
    then: yup.object().shape({
      value: yup.array().min(1).of(yup.string()).required('Angabe erforderlich'),
    }),
  }),
  painQualityIsNotAssessable: yup.boolean().notRequired().nullable(),
  painQuality: yup.mixed().when('painQualityIsNotAssessable', {
    is: false,
    then: yup.object().shape({
      value: yup.array().min(1).of(yup.string()).required('Angabe erforderlich'),
    }),
  }),
  accompanyingSymptomsIsNotAssessable: yup.boolean().notRequired().nullable(),
  accompanyingSymptoms: yup.mixed().when('accompanyingSymptomsIsNotAssessable', {
    is: false,
    then: yup.object().shape({
      value: yup.array().min(1).of(yup.string()).required('Angabe erforderlich'),
    }),
  }),
  symptomsOthers: yup.mixed().when('accompanyingSymptoms', {
    is: (v: ICheckboxValue) => v?.value?.includes('other'),
    then: yup.string().required(),
  }),
  durationOthers: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  factorsOthers: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  expressionOthers: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  painReliefOthers: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
});

export interface IPain {
  discontinued: boolean;
  painType: PainType;
  localizationIsNotAssessable: boolean;
  painLocation: string;
  painLocationType: ICheckboxValue;
  painQualityIsNotAssessable: boolean;
  painQuality: ICheckboxValue;
  accompanyingSymptomsIsNotAssessable: boolean;
  accompanyingSymptoms: ICheckboxValue;
  symptomsOthers: string;
}
